import React from 'react';
import { motion } from 'framer-motion';
import { Download, FileText, ExternalLink } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Resume() {
  const url = `${BACKEND_URL}/api/resume`;

  return (
    <section id="resume" className="relative py-24 lg:py-32" data-testid="resume-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="rounded-2xl border border-white/10 overflow-hidden bg-[#101012] relative">
          <div
            className="absolute -top-32 -right-32 w-96 h-96 rounded-full opacity-20 blur-3xl"
            style={{ background: '#e58a59' }}
          />
          <div className="relative p-10 lg:p-16">
            <div className="max-w-3xl">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                className="flex items-center gap-3 mb-6"
              >
                <FileText size={18} className="text-[#e58a59]" />
                <span className="text-xs uppercase tracking-[0.3em] text-zinc-400">
                  Resume / CV
                </span>
              </motion.div>

              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="font-display font-light text-white text-4xl lg:text-6xl leading-[1.05] mb-3"
                data-testid="resume-heading"
              >
                <span className="italic text-[#e58a59]">Stephanos Papas</span> —
                the condensed version, in PDF.
              </motion.h2>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 }}
                className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 mb-6"
              >
                Game Designer · 3D Artist · Hamburg
              </motion.div>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-zinc-400 text-base lg:text-lg max-w-xl leading-relaxed mb-8"
              >
                Studios, shipped titles, tooling and a list of the engines I
                speak fluently. One page. No filler.
              </motion.p>

              <div className="flex flex-wrap items-center gap-3">
                <a
                  href={url}
                  download="resume.pdf"
                  className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#e58a59] text-black font-semibold hover:bg-[#f0a075] transition-colors"
                  data-testid="resume-download-btn"
                >
                  <Download size={16} />
                  Download Resume
                </a>
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-white/20 text-white hover:border-white/60 transition-colors"
                  data-testid="resume-view-btn"
                >
                  <ExternalLink size={16} />
                  View in Browser
                </a>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-white/10 flex flex-wrap items-center gap-6 text-[11px] uppercase tracking-[0.25em] text-zinc-500">
              <span className="text-zinc-300">/ Resume.pdf</span>
              <span className="hidden sm:inline-block w-1 h-1 rounded-full bg-zinc-700" />
              <span>MA Game Design — BSBI Berlin</span>
              <span className="hidden sm:inline-block w-1 h-1 rounded-full bg-zinc-700" />
              <span>RTS Prototype — Unreal</span>
              <span className="hidden sm:inline-block w-1 h-1 rounded-full bg-zinc-700" />
              <span>QA — Keywords Studios</span>
              <span className="hidden sm:inline-block w-1 h-1 rounded-full bg-zinc-700" />
              <span>Updated · 2026</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
